import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { UseFormReset, UseFormSetError, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { LazyQueryTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import {
  QueryDefinition,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
// eslint-disable-next-line import/no-duplicates
} from '@reduxjs/toolkit/query';
// eslint-disable-next-line no-restricted-imports
import { ConfigFormSchema, IConfig } from '@modules/config/types';
// eslint-disable-next-line import/no-duplicates

export enum WORKING_DAYS_ENUM {
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
  saturday = "saturday",
  sunday = "sunday",
}

export interface WorkingDayConfig {
  enabled: boolean;
  from: string;
  to: string;
}

export interface ContactInfo {
  email: string;
  phone1?: string;
  phone2?: string;
}

export interface IConfigContent {}

export interface IFlowProcess {
  isLoading: boolean;
  isSuccess: string;
  isButtonLoading: boolean;
}

export interface CreateConfigState extends IFlowProcess {
}

export interface getConfigDataProps {
  reset: UseFormReset<ConfigFormSchema>;
  ConfigId: string;
  setState: Dispatch<SetStateAction<CreateConfigState>>;
  // eslint-disable-next-line max-len
  getConfigById: LazyQueryTrigger<QueryDefinition<string, BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, never, IConfig, "ConfigApi">>;
}

export interface onChangeUploadProps {
  event: ChangeEvent<HTMLInputElement>;
  multiple: boolean;
  watch: UseFormWatch<ConfigFormSchema>;
  setValue: UseFormSetValue<ConfigFormSchema>;
  setState: Dispatch<SetStateAction<CreateConfigState>>;
  setError: UseFormSetError<ConfigFormSchema>;
}

export interface OnChangeFunctionProps {
  multiple: boolean;
  event: ChangeEvent<HTMLInputElement>;
}
